import { Calendar, Icon, IconName } from '@/presentation/components';
import React from 'react';
import { Link } from 'react-router-dom';
import Styles from './item-styles.scss';
const SurveyItem = ({ survey }) => {
    const iconName = survey.didAnswer ? IconName.thumbUp : IconName.thumbDown;
    return (React.createElement("li", { className: Styles.surveyItemWrap },
        React.createElement("div", { className: Styles.surveyContent },
            React.createElement(Icon, { className: Styles.iconWrap, iconName: iconName }),
            React.createElement(Calendar, { date: survey.date, className: Styles.calendarWrap }),
            React.createElement("p", { "data-testid": "question" }, survey.question)),
        React.createElement("footer", null,
            React.createElement(Link, { "data-testid": "link", to: `/surveys/${survey.id}` }, "Check Results"))));
};
export default SurveyItem;
